<template>
  <div class="byxxhdIndex">
    <Header title="毕业信息核对" type="0" route="/homeIndex"></Header>
    <div class="selectRz" @click="selectRz">
      查看日志
    </div>
    <div class="byxxhdStatus">
      <span v-if="isCurrStu">
        您非当前毕业届别学生或管理员未初始化当前届别数据，不能核对！
      </span>
      <ul v-else>
        <li>学号：{{ this.info.xh }}</li>
        <li
          :class="{
            btgClass: true,
            ytgClass: status,
            shzClass: returnZtText() === '审核中'
          }"
        >
          当前状态：{{
            returnZtText() === "审核中"
              ? "核对中"
              : status
              ? "确认无误"
              : "待核对"
          }}
        </li>
      </ul>
    </div>
    <div
      v-if="!isCurrStu"
      class="byxxhdContent"
      :style="
        returnZtText() == '审核中' || returnZtText() == '审核通过'
          ? 'height:calc(100% - 90px - 20px )'
          : ''
      "
    >
      <van-form input-align="right">
        <van-cell-group inset v-for="(item, index) in labelList" :key="index">
          <!-- 下拉框 -->
          <van-field
            v-if="item.type == 1"
            v-model="$data[item.fieldname].mc"
            readonly
            @click="onShow(item.name, item.fieldname, item.flag)"
            :placeholder="`请点击选择${item.name}`"
          >
            <template #label>
              <span class="custom-title">{{ item.name }}</span>
            </template>
            <template v-if="item.flag != 3" #right-icon>
              <van-tag :type="returnType(item.flag)">{{
                returnText(item.flag)
              }}</van-tag>
            </template>
          </van-field>

          <template v-else-if="item.type == 3">
            <van-field readonly>
              <template #label>
                <span class="custom-title">{{ item.name }}</span>
              </template>
              <template v-if="item.flag != 3" #right-icon>
                <van-tag :type="returnType(item.flag)">{{
                  returnText(item.flag)
                }}</van-tag>
              </template>
            </van-field>
            <van-field readonly>
              <template #label>
                <img
                  class="headImg"
                  v-for="(item, index) in filemap"
                  :key="index"
                  :src="item.src"
                  alt=""
                />
              </template>
              <template #input>
                <van-uploader
                  v-if="item.flag === 1"
                  v-model="fileList"
                  :after-read="afterRead"
                  :max-size="10 * 1024 * 1024"
                  @oversize="onOversize"
                  :preview-image="false"
                />
              </template>
            </van-field>
          </template>

          <!-- 待核对0 已修改1 已确认2 -->
          <van-field
            v-else
            v-model="$data[item.fieldname]"
            :readonly="item.flag != 1 || item.type == 2"
            @click="
              item.type == 2
                ? onShowDate(item.name, item.fieldname, item.flag)
                : ''
            "
            :placeholder="
              item.type == 2 ? `请点击选择${item.name}` : `请填写${item.name}`
            "
          >
            <template #label>
              <span class="custom-title">{{ item.name }}</span>
            </template>
            <template v-if="item.flag != 3" #right-icon>
              <van-tag :type="returnType(item.flag)">
                {{ returnText(item.flag) }}
              </van-tag>
            </template>
          </van-field>
          <!-- 待核对0 已修改1 已确认2 -->
          <div class="btn" v-if="item.flag === 0">
            <van-button
              v-if="item.flag !== 1 && info[`${item.fieldname}hdjg`] == '3'"
              size="small"
              type="info"
              @click="confirm(item)"
            >
              确认无误
            </van-button>
            <!-- shbz:审核标志（0不能修改,1院系审核,2多级审核,3无需审核） -->
            <van-button
              v-if="item.shbz != 0"
              size="small"
              type="warning"
              @click="update(item)"
            >
              我要修改
            </van-button>
          </div>
        </van-cell-group>
      </van-form>
      <div
        v-if="returnZtText() !== '审核中' && returnZtText() !== '审核通过'"
        class="bottom-btn"
      >
        <button @click="push('save')">暂存</button>
        <button @click="push('ss')">送审</button>
      </div>
    </div>
    <!-- 出生日期 -->
    <van-popup v-model="showDate" position="bottom">
      <van-datetime-picker
        type="date"
        :title="dateList.label"
        @confirm="
          value => {
            onConfirmDate(value, dateList.value);
          }
        "
        @cancel="showDate = false"
      />
    </van-popup>
    <van-popup v-model="show" round position="bottom">
      <van-picker
        :title="valueList.label"
        show-toolbar
        :columns="valueList.item"
        @confirm="
          (value, index) => {
            onConfirm(value, index, valueList.value);
          }
        "
        @cancel="show = false"
      />
    </van-popup>
    <van-popup v-model="showPerson" position="bottom">
      <div class="apply-pop">
        <div class="pop-title">
          <i class="close-icon" @click="showPerson = false"></i>
          <p>审核人</p>
          <i class="confirm-icon" @click="resetCancel()"></i>
        </div>
        <div class="person">
          <button
            class="per-btn"
            ref="person"
            v-for="(item, index) in shrList"
            @click="personTap($event, index)"
            :key="item.id"
          >
            {{ item.name }}
          </button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Api } from "@/utils/axios";
export default {
  data() {
    return {
      shr: {},
      showPerson: false,
      shrList: [
        {
          id: "",
          name: "全部",
          isBtn: 0
        }
      ],
      status: "",
      czrzList: [],
      filemap: [],
      file: {},
      fileList: [],
      labelList: [],
      isCurrStu: false,
      xm: "",
      xsxmywmc: "",
      xbm: {},
      mzm: {},
      zzmmm: {},
      csrq: "",
      sfzjh: "",
      rxrq: "",
      bjbh: {},
      showDate: false,
      dateList: {
        label: "",
        value: ""
      },
      show: false,
      valueList: {
        label: "",
        value: "",
        item: []
      },
      columns: {},
      info: {},
      isChoosePerson: false,
      val: "",
      params: {}
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 审核人弹框中的按钮选择
    personTap(e, res) {
      let strList = [];
      let idList = [];
      if (this.shrList[res].isBtn == 0) {
        this.shrList[res].isBtn = 1;
        e.target.className = "cur";
      } else if (this.shrList[res].isBtn == 1) {
        this.shrList[res].isBtn = 0;
        e.target.className = "per-btn";
      }
      for (let i in this.shrList) {
        if (this.shrList[res].name == "全部") {
          this.shrList[i].isBtn = 0;
          this.shrList[res].isBtn = 1;
          this.$refs.person[res].className = "cur";
          this.$refs.person[i].className = "per-btn";
        } else {
          this.shrList[0].isBtn = 0;
          this.$refs.person[0].className = "per-btn";
        }
        if (this.shrList[i].isBtn == 1) {
          strList = strList.concat(this.shrList[i].name);
          idList = idList.concat(this.shrList[i].id);
        }
      }
      this.reset = strList.toString();
      this.resetId = idList.toString();
    },
    // 审核人选择完后点击确认
    resetCancel() {
      if (this.resetId == undefined) {
        this.$toast.fail("请选择送审人！");
        setTimeout(() => {
          this.showPerson = false;
        }, 1500);
        return;
      }
      this.showPerson = false;
      this.shr.mc = this.reset;
      this.shr.dm = this.resetId;

      this.params.userids = this.shr.dm;
      this.SubmitEvent();
    },
    async getShr() {
      let concatList2 = [];
      let concatList3 = [];
      const params = {
        ywcode: "100",
        ywid: ""
      };
      const res = await Api.selectReviewerApi(params);
      res.data.forEach((item, index) => {
        concatList2[index] = {
          name: item.userrealname,
          id: item.userid,
          isBtn: 0
        };
      });
      this.shrList = this.shrList.concat(concatList2);
    },
    update(item) {
      item.flag = 1;
      if (!!this.info[`new${item.fieldname}`]) {
        if (item.type == 1) {
          this.defaultSelect(item.fieldname, this.info[`new${item.fieldname}`]);
        } else if (item.type == 3) {
          this.filemap[0] = {
            src: this.info.newzpBase64
          };
          console.log(this.filemap);
        } else {
          this[item.fieldname] = this.info[`new${item.fieldname}`];
        }
        return;
      }
      if (item.type == 1) {
        this[item.fieldname] = {};
      } else {
        this[item.fieldname] = "";
      }
    },
    defaultSelect(name, newDm) {
      let newDefaultIndex = 0;
      this.columns[name][0].values.forEach((item, index) => {
        if (item.value == newDm) {
          newDefaultIndex = index;
          this[name] = {
            mc: item.text,
            dm: item.value
          };
        }
      });
      this.columns[name][0].defaultIndex = newDefaultIndex;
    },
    async confirm(item) {
      let data = {
        type: "qr",
        fieldname: item.fieldname,
        name: item.name,
        xsxxhd0101id: this.info.id
      };
      if (item.fieldname == "zp") {
        data[`old${item.fieldname}`] = this.info[item.fieldname];
        data[`new${item.fieldname}`] = "";
      } else if (item.type == "1") {
        if (item.fieldname == "bjbh") {
          data[`old${item.fieldname}`] = this.info.bj;
        } else {
          data[`old${item.fieldname}`] = this.info[
            item.fieldname.substr(0, item.fieldname.length - 1)
          ];
        }

        if (this[item.fieldname].dm == this.info[item.fieldname]) {
          data[`new${item.fieldname}`] = "";
        } else {
          data[`new${item.fieldname}`] = this[item.fieldname].dm;
          data[`new${item.fieldname}mc`] = this[item.fieldname].mc;
        }
      } else {
        data[`old${item.fieldname}`] = this.info[item.fieldname];
        if (this[item.fieldname] == this.info[item.fieldname]) {
          data[`new${item.fieldname}`] = "";
        } else {
          data[`new${item.fieldname}`] = this[item.fieldname];
        }
      }
      const res = await Api.byxxhd(data);
      item.flag = 2;
      this.status = this.labelList.every(oitem => {
        return oitem.flag == 2;
      });
    },
    returnZtText() {
      switch (this.info.iswfmes) {
        case "0":
          return "审核不通过";
        case "1":
          return "审核通过";
        case "2":
          return "审核中";
        case "3":
          return "待送审";
        default:
          return "待核对";
      }
    },
    returnType(val) {
      switch (val) {
        case 0:
          return "danger";
        case 1:
          return "warning";
        case 2:
          return "info";
      }
    },
    returnText(val) {
      switch (val) {
        case 0:
          return "待核对";
        case 1:
          return "已修改";
        case 2:
          return "已确认";
      }
    },
    selectRz() {
      this.$router.push({
        path: "/byxxhd/selectRz",
        query: {
          list: this.czrzList
        }
      });
    },
    onOversize(file) {
      this.$toast.fail("文件大小不能超过10M");
    },
    // 上传附件
    async afterRead(file) {
      let obj = {
        fileName: file.file.name,
        fileSize: file.file.size,
        src: file.content
      };
      this.filemap[0] = obj;
    },
    push(val) {
      this.val = val;

      let zcValue = this.labelList.map(item => {
        let data = {
          fieldname: item.fieldname,
          name: item.name
        };

        if (item.fieldname == "zp") {
          data[`old${item.fieldname}`] = this.info[item.fieldname];
          data[`new${item.fieldname}`] = "";
        } else if (item.type == "1") {
          if (item.fieldname == "bjbh") {
            data[`old${item.fieldname}`] = this.info.bj;
          } else {
            data[`old${item.fieldname}`] = this.info[
              item.fieldname.substr(0, item.fieldname.length - 1)
            ];
          }

          if (this[item.fieldname].dm == this.info[item.fieldname]) {
            data[`new${item.fieldname}`] = "";
          } else {
            data[`new${item.fieldname}`] = this[item.fieldname].dm;
            data[`new${item.fieldname}mc`] = this[item.fieldname].mc;
          }
        } else {
          data[`old${item.fieldname}`] = this.info[item.fieldname];
          if (this[item.fieldname] == this.info[item.fieldname]) {
            data[`new${item.fieldname}`] = "";
          } else {
            data[`new${item.fieldname}`] = this[item.fieldname];
          }
        }
        return data;
      });
      this.params = {
        type: this.val,
        zcValue: encodeURI(JSON.stringify(zcValue)),
        xsxxhd0101id: this.info.id,
        file1: ""
      };
      if (this.fileList.length > 0) {
        this.params.file1 = this.fileList[0].file;
      }
      if (this.val == "ss" && this.isChoosePerson) {
        this.showPerson = true;
      } else {
        this.SubmitEvent();
      }
    },
    async SubmitEvent() {
      const res = await Api.byxxhd(this.params);
      if (res.code == "1") {
        this.$toast.success(this.val == "save" ? "暂存成功！" : "送审成功");
        setTimeout(() => {
          this.$router.back();
        }, 1500);
      } else {
        this.$toast.fail(res.msg);
      }
    },
    async getList() {
      let selectArr = ["性别", "民族", "政治面貌", "班级"];
      let dateArr = ["出生日期", "入学日期"];
      let ImgArr = ["照片"];
      const res = await Api.byxxhd({ type: "ck" });
      if (res.code === "1") {
        if (res.xsList.length == 0) {
          this.isCurrStu = true;
        } else {
          if (res.djshList > 0) {
            this.isChoosePerson = true;
            this.getShr();
          }
          this.czrzList = res.czrz;
          this.columns.xbm = [
            {
              values: res.xbList.map(item => {
                return {
                  text: item.dmmc,
                  value: item.dm
                };
              })
            }
          ];
          this.columns.mzm = [
            {
              values: res.mzList.map(item => {
                return {
                  text: item.dmmc,
                  value: item.dm
                };
              })
            }
          ];
          this.columns.zzmmm = [
            {
              values: res.zzmmList.map(item => {
                return {
                  text: item.dmmc,
                  value: item.dm
                };
              })
            }
          ];
          this.columns.bjbh = [
            {
              values: res.bjList.map(item => {
                return {
                  text: item.bj,
                  value: item.bh
                };
              })
            }
          ];
          this.info = res.xsList[0];
          this.labelList = res.shbzList.map(item => {
            this[item.fieldname] = this.info[item.fieldname];
            item.type = 0;
            // 待核对0 已修改1 已确认2
            //数据库 待确认3 审核中2 已确认1
            item.flag =
              res.xsList[0][`${item.fieldname}hdjg`] == 1
                ? 2
                : res.xsList[0][`${item.fieldname}hdjg`] == 3
                ? 0
                : 3;
            selectArr.forEach(oitem => {
              if (item.name === oitem) {
                if (item.fieldname == "bjbh") {
                  this[item.fieldname] = {
                    mc: this.info.bj,
                    dm: this.info.bjbh
                  };
                } else {
                  this[item.fieldname] = {
                    mc: this.info[
                      item.fieldname.substr(0, item.fieldname.length - 1)
                    ],
                    dm: this.info[item.fieldname]
                  };
                }
                item.type = 1;
              }
            });
            dateArr.forEach(oitem => {
              if (item.name === oitem) {
                item.type = 2;
              }
            });
            ImgArr.forEach(oitem => {
              if (item.name === oitem) {
                item.type = 3;
              }
            });
            return item;
          });
          console.log(this.labelList);
          this.filemap[0] = { src: res.xsList[0].zpBase64 };
          this.status = this.labelList.every(oitem => {
            return oitem.flag == 2;
          });
        }
      }
    },
    onShow(label, value, flag) {
      if (flag === 1) {
        this.show = true;
        this.valueList.label = label;
        this.valueList.value = value;
        this.valueList.item = this.columns[value];
      }
    },
    onConfirm(value, index, value1) {
      this.show = false;
      this[value1].mc = value[0].text;
      this[value1].dm = value[0].value;
    },
    onShowDate(label, value, flag) {
      if (flag === 1) {
        this.showDate = true;
        this.dateList.label = label;
        this.dateList.value = value;
      }
    },
    onConfirmDate(time, value) {
      this[value] = new Date(time).format("yyyy-MM-dd");
      this.showDate = false;
    },
    timeFormatter(type, val) {
      if (type === "year") {
        return val + "年";
      }
      if (type === "month") {
        return val + "月";
      }
      if (type === "day") {
        return val + "日";
      }
      return val;
    }
  }
};
</script>

<style lang="less" scoped>
.byxxhdIndex {
  height: 100%;
  background-color: #f7f8fa;
  overflow: auto;
  .shzClass {
    color: #7469f8 !important;
  }
  .btgClass {
    color: #f86969 !important;
  }
  .ytgClass {
    color: #12ddd6 !important;
  }
  .dssClass {
    color: #757da3 !important;
  }
  .selectRz {
    background: #7469f8;
    border-radius: 8px;
    color: #fff;
    padding: 10px 16px;
    margin: 8px 16px 10px;
    text-align: center;
  }
  .byxxhdStatus {
    border-radius: 8px;
    background-color: #fff;
    margin: 8px 16px 10px;
    padding: 10px 16px;
    ul {
      display: flex;
      justify-content: space-between;
      li:last-child {
        font-weight: bold;
      }
    }
  }
  .byxxhdContent {
    height: calc(~"100% - 90px - 18px - 70px");
    overflow: auto;
    padding-bottom: 10px;
    box-sizing: border-box;
    .van-cell-group {
      .headImg {
        width: 80px;
        height: 80px;
      }
      & + .van-cell-group {
        margin-top: 10px;
      }
      .van-cell {
        padding: 14px 16px;
      }
      .van-cell.van-field .van-cell__title.van-field__label .van-tag {
        color: #fff;
      }
      /deep/.van-field__control--right {
        font-weight: bold;
      }
      .van-tag--danger {
        background-color: #f86969;
      }
      .van-tag--info {
        background-color: #12ddd6;
      }
      .btn {
        display: flex;
        justify-content: flex-end;
        padding: 10px 16px;
        .van-button--info {
          background-color: #12ddd6;
          border-color: #12ddd6;
        }
        .van-button + .van-button {
          margin-left: 10px;
        }
      }
    }
  }
  /* 审核人 */
  .close-icon {
    background: url(../../../../../static/img/close.png) no-repeat center;
  }
  .confirm-icon {
    background: url(../../../../../static/img/confirm.png) no-repeat center;
  }
  .pop-title i {
    width: 22px;
    height: 22px;
    background-size: 22px 22px;
    padding: 10px;
  }
  .pop-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .person {
    padding: 15px;
  }
  .person button {
    border-radius: 3px;
    padding: 5px 15px;
    margin-right: 12px;
    margin-bottom: 10px;
  }
  .apply-pop .person .per-btn {
    background-color: #ecedfd;
    color: #7469f8;
  }
  .person .cur {
    background-color: #7469f8;
    color: #ecedfd;
  }
  .bottom-btn {
    box-sizing: border-box;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 70px;
    padding: 10px 5% 10px 5%;
    background: #fff;
    display: flex;
    justify-content: space-between;

    // button {
    //   width: 100%;
    //   height: 44px;
    //   background: #7469f8;
    //   border-radius: 3px;
    //   color: #fff;
    // }
    button:first-child {
      width: 47.5%;
      height: 44px;
      background: #ecedfd;
      border-radius: 3px;
      color: #7469f8;
    }
    button:last-child {
      width: 47.5%;
      height: 44px;
      background: #7469f8;
      border-radius: 3px;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/byxxhd/index.vue